import { Box } from '@mui/material';

interface TabPanelProps {
  index: number | string;
  value: number | string;
  children?: React.ReactNode;
  height?: string;
  width?: string;
}

export default function TabsPanel({
  index,
  value,
  children,
  width,
}: TabPanelProps) {
  return (
    <Box
      hidden={value !== index}
      sx={{
        overflow: 'auto',
        height: '100%',
        width: width ? width : undefined,
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-track': {
          background: 'rgba(0,0,0,0.1)',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: 'rgba(0,0,0,0.3)',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: 'rgba(0,0,0,0.5)',
        }
      }}
    >
      {value === index && children}
    </Box>
  );
}
